import { getMakeAPI, Method } from '@golden/getch';
export function createAuthTransferService(prefix, api) {
    const makeAPI = getMakeAPI(`${prefix}v1`);
    const AUTH_TRANSFER_API = {
        TRANSFER: makeAPI(Method.GET, 'transfer')(),
        TRANSFER_LOGIN: makeAPI(Method.POST, 'transfer/login')()
    };
    return {
        transfer: () => api.fetch(AUTH_TRANSFER_API.TRANSFER),
        ...((prefix === '')
            ? {
                transferLogin(token) {
                    return api.fetch(AUTH_TRANSFER_API.TRANSFER_LOGIN, { config: { headers: { Authorization: `Bearer ${token}` } } });
                }
            }
            : {})
    };
}
//# sourceMappingURL=TransferService.js.map